export default __webpack_public_path__ + "static/media/img3.a53a7173.jpg";